module.exports = __webpack_public_path__ + "static/media/Isolation Effect, Von Restorff Effect.4cb622e0.jpg";